import {
  Box,
  Input,
  InputProps,
  Select,
  Spinner,
  useBreakpointIndex,
} from '@apia/theme';
import { useAutocompleteContext } from './Context';
import { observer } from 'mobx-react-lite';
import { Icon } from '@apia/icons';
import { useRef } from 'react';

export const SearchBox = observer((props: InputProps) => {
  const handler = useAutocompleteContext();
  const breakpoint = useBreakpointIndex();
  const nativeSelectBreakpoint = handler.state.nativeSelectBreakpoint ?? 3;
  const boxRef = useRef<HTMLInputElement>(null);

  return (
    <Box className="autocomplete__inputWrapper" ref={boxRef}>
      <input
        type="hidden"
        name={handler.state.name}
        value={handler.state.value}
      />
      {breakpoint <= nativeSelectBreakpoint ? (
        <Select
          disabled={handler.state.disabled || handler.state.readOnly}
          onChange={(ev) => {
            handler.setValue(ev.target.value);
          }}
          value={handler.state.value ?? ''}
        >
          {handler.state.options.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </Select>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
          }}
          onClick={() => {
            handler.state.width =
              boxRef.current?.getBoundingClientRect().width ??
              handler.state.width;

            handler.toggleOpen();
          }}
        >
          <Input
            {...props}
            className={`autocomplete__search ${handler.state.disabled ? 'disabled' : ''} ${handler.state.readOnly ? 'readOnly' : ''}`}
            onChange={async (ev) => {
              handler.search(ev.target.value);
              props.onChange?.(ev);
            }}
            onClick={() => {
              handler.state.width =
                boxRef.current?.getBoundingClientRect().width ??
                handler.state.width;

              handler.toggleOpen();
            }}
            onFocus={(ev) => {
              ev.target.setSelectionRange(0, ev.target.value.length);
            }}
            onBlur={() => {
              handler.close();
            }}
            value={handler.state.showValue}
          />
          <Box className="autocomplete__icons">
            {handler.state.loading && (
              <Spinner className="autocomplete__loadingSpinner" />
            )}
            <Icon
              title=""
              name={handler.state?.icon || 'ArrowDown'}
              className="autocomplete__downArrow"
            />
          </Box>
        </Box>
      )}
    </Box>
  );
});
